import React from 'react';

export interface AssetInfoPanelData {
  label: string;
  data: React.ReactNode;
}
export interface AssetInfoPanelProps {
  data: AssetInfoPanelData[];
}
export function AssetInfoPanel(props: AssetInfoPanelProps) {
  const { data } = props;

  return (
    <div className='text-sm flex flex-col'>
      <div className='flex flex-col gap-y-2 text-xs'>
        {data.length > 0 ? (
          data.map((a) => {
            return (
              <div key={a.label} className='whitespace-nowrap flex'>
                <div className='w-20'>{a.label}</div>
                <div className='text-baseText'>{a.data}</div>
              </div>
            );
          })
        ) : (
          <div className='text-baseText'>暂无更多细节信息</div>
        )}
      </div>
    </div>
  );
}
